import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M17.981 10.776v4.617c0 .541.215 1.06.598 1.444s.598.902.598 1.444a.35.35 0 0 1-.35.35H5.173a.35.35 0 0 1-.35-.35c0-.542.215-1.061.598-1.444s.598-.903.598-1.444V8.98a5.98 5.98 0 0 1 8.796-5.279c.693.38 1.85 2.242 1.168 4.173-.778 2.198-3.38 1.258-3.38-.464 0-2.123 3.29-4.261 5.443-2.004"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M14.393 18.631a2.393 2.393 0 0 1-4.785 0"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M12 3c1.018 0 1.976.254 2.815.702.22.12.486.39.726.763m0 0c.516.804.908 2.091.441 3.41-.777 2.198-3.379 1.258-3.379-.464 0-1.375 1.38-2.757 2.938-2.946m0 0c.847-.103 1.746.147 2.505.942"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const NotificationIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
